import type { TimelineEvent } from './types';

export const sampleTimelineEvents: TimelineEvent[] = [
  {
    id: '1',
    title: 'Senior React Developer',
    category: 'work',
    date: new Date('2023-01-01'),
    type: 'work',
    start_date: '2023-01-01',
    end_date: '2023-12-31',
    heading: 'Senior React Developer',
    description: `
# Senior React Developer at TechCorp

Led development of multiple React applications with a team of 5 developers.

## Key Achievements:
- **Improved Performance**: Reduced bundle size by 40% through code splitting
- **Team Leadership**: Mentored 3 junior developers
- **Architecture**: Designed scalable component library used across 10+ projects

## Technologies Used:
- React 18 with TypeScript
- Redux Toolkit for state management
- Styled Components for styling
- Jest and React Testing Library for testing
    `,
    company: {
      id: '1',
      name: 'TechCorp',
      logo_url: 'https://placehold.co/150x150/3B82F6/FFFFFF?text=TC',
      website_url: 'https://techcorp.com',
    },
    tech_stack_summary: [
      'React',
      'TypeScript',
      'Redux',
      'Styled Components',
      'Jest',
    ],
    projects: [
      {
        id: '1',
        title: 'E-commerce Platform',
        description:
          'Built a full-stack e-commerce solution with React frontend and Node.js backend',
        start_date: '2023-03-01',
        end_date: '2023-06-01',
        techStack: ['React', 'Node.js', 'MongoDB', 'Stripe'],
        links: [
          {
            id: '1',
            platform: 'github',
            url: 'https://github.com/user/ecommerce-platform',
          },
          {
            id: '2',
            platform: 'web',
            url: 'https://ecommerce-demo.com',
          },
        ],
      },
      {
        id: '2',
        title: 'Admin Dashboard',
        description:
          'Created comprehensive admin dashboard with real-time analytics',
        start_date: '2023-07-01',
        end_date: '2023-09-01',
        techStack: ['React', 'Chart.js', 'Socket.io', 'Express'],
        live_url: 'https://admin-dashboard-demo.com',
      },
    ],
  },
  {
    id: '2',
    title: 'Bachelor of Computer Science',
    category: 'education',
    date: new Date('2020-09-01'),
    type: 'education',
    start_date: '2020-09-01',
    end_date: '2024-05-01',
    heading: 'Bachelor of Computer Science',
    description: `
# Computer Science Degree

Studied computer science with focus on software engineering and web development.

## Course Highlights:
- **Data Structures & Algorithms**: Advanced problem solving techniques
- **Web Development**: Full-stack development with modern technologies
- **Database Systems**: SQL and NoSQL database design
- **Software Engineering**: Agile methodologies and best practices

## Projects:
- Built a social media platform using React and Node.js
- Developed a machine learning model for image classification
- Created a real-time chat application with WebSockets
    `,
    tech_stack_summary: [
      'Java',
      'Python',
      'JavaScript',
      'SQL',
      'React',
      'Node.js',
    ],
  },
  {
    id: '3',
    title: 'Frontend Developer',
    category: 'work',
    date: new Date('2021-06-01'),
    type: 'work',
    start_date: '2021-06-01',
    end_date: '2022-12-31',
    heading: 'Frontend Developer',
    description: `
# Frontend Developer at StartupXYZ

Developed responsive web applications using modern JavaScript frameworks.

## Responsibilities:
- Built responsive user interfaces with React and Vue.js
- Implemented state management with Redux and Vuex
- Collaborated with designers to create pixel-perfect implementations
- Optimized application performance and user experience

## Key Projects:
- **Customer Portal**: React-based customer management system
- **Mobile App**: Progressive Web App for mobile users
- **Analytics Dashboard**: Real-time data visualization
    `,
    company: {
      id: '2',
      name: 'StartupXYZ',
      logo_url: 'https://placehold.co/150x150/10B981/FFFFFF?text=SX',
      website_url: 'https://startupxyz.com',
    },
    tech_stack_summary: [
      'React',
      'Vue.js',
      'JavaScript',
      'CSS3',
      'HTML5',
      'Webpack',
    ],
  },
  {
    id: '4',
    title: 'Started Open Source Contributions',
    category: 'life',
    date: new Date('2022-03-15'),
    type: 'life',
    start_date: '2022-03-15',
    heading: 'Started Open Source Contributions',
    description: `
# Open Source Journey

Began contributing to open source projects and building a presence in the developer community.

## Contributions:
- **React Libraries**: Contributed to popular React component libraries
- **Documentation**: Improved documentation for various projects
- **Bug Fixes**: Fixed critical bugs in production applications
- **Feature Development**: Added new features to open source tools

## Impact:
- 50+ pull requests merged
- 1000+ stars on personal projects
- Speaker at local developer meetups
- Mentor for new contributors
    `,
    tech_stack_summary: ['Git', 'GitHub', 'Open Source', 'Community'],
  },
  {
    id: '5',
    title: 'Lead Frontend Architect',
    category: 'work',
    date: new Date('2024-01-01'),
    type: 'work',
    start_date: '2024-01-01',
    end_date: 'present',
    heading: 'Lead Frontend Architect',
    description: `
# Lead Frontend Architect at InnovationLab

Leading frontend architecture decisions and mentoring development teams.

## Current Role:
- **Architecture Design**: Designing scalable frontend architectures
- **Team Leadership**: Leading team of 8 frontend developers
- **Technology Strategy**: Making technology decisions for the organization
- **Performance Optimization**: Ensuring optimal performance across all applications

## Recent Achievements:
- Implemented micro-frontend architecture
- Reduced build times by 60%
- Established coding standards and best practices
- Introduced automated testing strategies
    `,
    company: {
      id: '3',
      name: 'InnovationLab',
      logo_url: 'https://placehold.co/150x150/8B5CF6/FFFFFF?text=IL',
      website_url: 'https://innovationlab.com',
    },
    tech_stack_summary: [
      'React',
      'TypeScript',
      'Micro-frontends',
      'Webpack',
      'Jest',
      'Cypress',
    ],
    projects: [
      {
        id: '3',
        title: 'Micro-frontend Platform',
        description:
          'Designed and implemented a micro-frontend architecture supporting 15+ applications',
        start_date: '2024-02-01',
        end_date: null,
        techStack: ['Module Federation', 'React', 'TypeScript', 'Webpack 5'],
        links: [
          {
            id: '3',
            platform: 'github',
            url: 'https://github.com/innovationlab/micro-frontend-platform',
          },
        ],
      },
    ],
  },
];
